import {Badge, classNames, layout, PushButton, typography, useAsyncCallback, View} from "@variocube/cube-ui";
import * as React from "react";
import {useState} from "react";
import {stylesheet} from "typestyle";
import {Controller} from "../controller/Controller";
import {useLocalization} from "../../i18n";
import {useFlag} from "@variocube/app-ui";

interface PaymentTerminalViewProps {
    controller: Controller;
}

export function PaymentTerminalView({controller}: PaymentTerminalViewProps) {
    const {t, language} = useLocalization();
    const [message, setMessage] = useState<string[]>([]);
    // const [started, setStarted, clearStarted] = useFlag(false);

    const initiate = useAsyncCallback(async (amount: number) => {
        return await controller.paymentTerminal.initiatePayment(amount, "EUR", language, setMessage);
    }, [controller, language]);

    const confirm = useAsyncCallback(async () => {
        await controller.paymentTerminal.confirmPayment();
        initiate.clear();
    }, [controller, initiate.clear]);

    const cancel = useAsyncCallback(async () => {
        await controller.paymentTerminal.cancelPayment();
        initiate.clear();
    }, [controller, initiate.clear]);

    return (
        <View className={layout.paddingMedium}>
            <div className={classNames(typography.colorError, styles.line)}>
                {t("PaymentWarning")}
            </div>
            <div className={classNames(styles.line)}>
                <PushButton primary onClick={() => initiate.execute(0.01)} disabled={initiate.loading || !!initiate.result}>
                    {t("InitiatePayment")}
                </PushButton>
                <PushButton primary onClick={() => initiate.execute(1)} disabled={initiate.loading || !!initiate.result}>
                    InitiatePayment 1 EUR
                </PushButton>
                {" "}
                <PushButton success onClick={confirm.execute} disabled={!initiate.result}>
                    {t("ConfirmPayment")}
                </PushButton>
                {" "}
                <PushButton danger onClick={cancel.execute} disabled={!initiate.result && !initiate.loading}>
                    {t("CancelPayment")}
                </PushButton>
            </div>

            <div className={styles.line}>
                Status:
                {" "}
                {initiate.loading && (
                    <Badge>Pending</Badge>
                )}
                {initiate.error && (
                    <Badge>Denied</Badge>
                )}
                {!initiate.loading && initiate.result && (
                    <Badge>Approved</Badge>
                )}
                {" "}
            </div>

            <div className={styles.line}>
                <div>Message from terminal:</div>
                <div className={styles.message}>{message}</div>
            </div>

            {initiate.result && (
                <div className={styles.line}>
                    <pre>{initiate.result.receiptText}</pre>
                </div>
            )}

            {initiate.error && (
                <div className={styles.line}>
                    <pre>{JSON.stringify(initiate.error, null, 4)}</pre>
                </div>
            )}

        </View>
    );

}

const styles = stylesheet({
    line: {
        margin: "0.75em 0"
    },
    message: {
        backgroundColor: "#f0f0f0",
        padding: "0.75em 1.5em",
        borderRadius: "0.25em",
        margin: "0.75em 0"
    }
});